/**
 * Fictora 品牌 - Welfare 页面配置
 */
import { welfareCommonConfig } from './common'
import type { WelfarePageConfig } from './types'
import { theme as brandTheme } from '@/config/brands'

export const theme = {
  btnBg: brandTheme.primaryColor,
  btnText: brandTheme.textPrimary,
  coinsColor: brandTheme.textPrimary,
} as const

export const resources = {
  homeBg: '',
  welfareGold: '/images/fictora/welfare-gold.png',
  welfareBox: '/images/fictora/welfare-box.png',
} as const

export const welfareConfig: WelfarePageConfig = {
  theme,
  resources,
  texts: welfareCommonConfig.texts,
}
